// App Version Configuration
// Update this file at each deployment

export const APP_VERSION = "1.5.0";
export const LAST_UPDATE_DATE = "2026-03-01";

// Changelog entries (most recent first)
export const CHANGELOG = [
  {
    version: "1.5.0",
    date: "2026-03-01",
    changes: [
      "Ajout de la page Statistiques d'achats avec comparateur de prix",
      "Nouvel onglet Réglages sur le profil (email, mot de passe, budget)",
      "Animation check vert après scan de ticket",
      "Nom de boutique cliquable vers la fiche commerce",
      "Scroll automatique en haut lors de la navigation"
    ]
  },
  {
    version: "1.4.0",
    date: "2026-02-28",
    changes: [
      "Système de notification par email complet (9 templates)",
      "Flux d'abonnement B2B avec Stripe",
      "Gestion des rappels produits avec photos",
      "Page de découverte d'utilisateurs"
    ]
  },
  {
    version: "1.3.0",
    date: "2026-02-25",
    changes: [
      "Refactoring complet du backend (architecture modulaire)",
      "Badge Pro dans le header",
      "Recettes favorites sur le profil",
      "Page de notifications dédiée"
    ]
  },
  {
    version: "1.2.0",
    date: "2026-02-20",
    changes: [
      "Boutique e-commerce avec paiement Stripe",
      "Système de points et gamification",
      "Annuaire des commerces de proximité"
    ]
  },
  {
    version: "1.1.0",
    date: "2026-02-15",
    changes: [
      "Système social (amis, repas collaboratifs)",
      "Notation multi-critères des repas",
      "Portail B2B pour les professionnels"
    ]
  },
  {
    version: "1.0.0",
    date: "2026-02-01",
    changes: [
      "Lancement de Gusto",
      "Création et partage de recettes",
      "Scan de tickets de caisse",
      "Cave à vin personnelle"
    ]
  }
];
